import React from 'react';
import { DkvSettingsSection } from '../DkvSettingsSection';
import { IdsSettingsSection } from '../IdsSettingsSection';
import { ApiKeysSettingsSection } from '../api/ApiKeysSettingsSection';
import { MeinshkSettingsSection } from '../MeinshkSettingsSection';
import { MetalQuotesSettingsCard } from '../MetalQuotesSettingsCard';
import { OmdSettingsSection } from '../OmdSettingsSection';
import { INTEGRATIONS, dkvStatus, idsStatus, leadApiStatus, meinshkStatus, metalStatus, omdStatus, type Status } from './integrationCatalog';
import { IntegrationDetailLayout } from './integrationUi';

const PAGES = {
  omd: { load: omdStatus, Body: OmdSettingsSection },
  ids: { load: idsStatus, Body: IdsSettingsSection },
  metal: { load: metalStatus, Body: MetalQuotesSettingsCard },
  dkv: { load: dkvStatus, Body: DkvSettingsSection },
  lead_api: { load: leadApiStatus, Body: ApiKeysSettingsSection },
  meinshk: { load: meinshkStatus, Body: MeinshkSettingsSection },
} as const;

/** Detailseite für Integrationen ohne eigene Unterseite: Kopf aus dem Katalog, darunter die bisherige Karte. */
export function IntegrationDetailPage({ id, onBack }: { id: keyof typeof PAGES; onBack: () => void }) {
  const integration = INTEGRATIONS.find((item) => item.id === id)!;
  const { load, Body } = PAGES[id];
  const [status, setStatus] = React.useState<Status | null>(null);

  React.useEffect(() => {
    let cancelled = false;
    load()
      .then((next) => {
        if (!cancelled) setStatus(next);
      })
      .catch(() => {
        if (!cancelled) setStatus(null);
      });
    return () => {
      cancelled = true;
    };
  }, [load]);

  return (
    <IntegrationDetailLayout
      mark={integration.mark}
      title={integration.name}
      state={status?.state}
      description={status?.detail ? `${integration.description} · ${status.detail}` : integration.description}
      onBack={onBack}
    >
      <Body />
    </IntegrationDetailLayout>
  );
}
